/** @jsxImportSource @emotion/react */
import { Column, Layout, Row } from '@ssmm/ui';
import { arrowRight } from 'components/landing/ui/icons';
import { Link as RouterLink } from 'react-router-dom';

import bg1x from '../../images/s2-bg-1x.png';
import bg2x from '../../images/s2-bg-2x.png';
import bg3x from '../../images/s2-bg-3x.png';
import { Button, colors, HeadingH2, Modal, Text, TextItalic } from '../../ui';
import { Dot } from '../s3/left-col';

const Tariffs = ({ onClose }) => (
  <Modal
    title="VK-BO$$ самый безопасный и самый доступный сервис"
    onClose={onClose}
    getContainer={() => document.getElementById('root')}
    width={996}
  >
    <Column
      css={{
        padding: `30px 0 35px 30px`,
      }}
      shrink={1}
      overflow="hidden"
    >
      <Column
        css={{
          paddingRight: 30,
        }}
        scroll
        align="center"
      >
        <HeadingH2 css={{ textAlign: 'center', marginBottom: 30 }}>
          Стоимость начинается <span css={{ color: colors.blue }}>от 20 рублей</span> в день
        </HeadingH2>

        <Row
          align="center"
          marginBottom={30}
          paddingBottom={30}
          css={{ borderBottom: `1px solid ${colors.black}` }}
        >
          <div
            css={{
              display: 'none !important',
              flexBasis: '40%',
              flexGrow: 1,
              marginRight: 30,
              '@media (min-width:700px)': { display: 'flex  !important' },
            }}
          >
            <img
              srcSet={`${bg1x} 1x, ${bg2x} 2x, ${bg3x} 3x`}
              css={{ width: '100%', maxWidth: 500 }}
            />
          </div>

          <Layout
            direction="column"
            grow={1}
            basis="40%"
            css={{
              '>div': { alignItems: 'center' },
              '>div:not(:last-of-type)': { marginBottom: 20 },
            }}
          >
            <Layout>
              <Dot />
              <Text>
                Вам не нужно оставлять свой <span css={{ color: colors.blue }}>пароль</span>
              </Text>
            </Layout>
            <Layout>
              <Dot />
              <Text>Специальные акции и предложения для новых пользователей</Text>
            </Layout>
            <Layout>
              <Dot />
              <Text>Разные пакеты позволят собрать свой тариф</Text>
            </Layout>
            <Layout>
              <Dot />
              <Text>В сервисе доступны некоторые бесплатные функции</Text>
            </Layout>
          </Layout>
        </Row>

        <Layout
          css={{
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            '>div:nth-of-type(1)': { marginBottom: 20 },
            '@media (min-width:750px)': {
              flexDirection: 'row',
              justifyContent: 'space-between',
              '>div:nth-of-type(1)': { marginBottom: 0 },
            },
          }}
        >
          <Layout align="center" shrink={1}>
            <TextItalic css={{ color: colors.grayLight }}>
              Управление тарифами происходит после активации
            </TextItalic>
          </Layout>

          {/* <RouterLink to="/lk" target="_blank">
          </RouterLink> */}
          <Button
            onClick={() => window.open('https://vk-boss-light.web.app/guide', '_blank')}
            type="blue"
            icon={arrowRight}
          >
            Попробовать бесплатно на 3 дня
          </Button>
        </Layout>
      </Column>
    </Column>
  </Modal>
);

export default Tariffs;
